import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['globalPaywallBannerDismissed'] = false,
  action: Action,
): RootState['globalPaywallBannerDismissed'] {
  switch (action.type) {
    case 'GLOBAL_PAYWALL_BANNER_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
